import React from "react";
import { NavLink } from "react-router-dom";

const TABS = [["/admin/affiliates", "Affiliates", "nav-affiliates"], ["/admin/affiliates/history", "History", "nav-affiliate-history"], ["/admin/affiliates/problems", "Problem Links", "nav-problem-links"]];

export const AffiliateNav = () => (
  <nav className="flex gap-1 mt-3" data-testid="affiliate-nav">
    {TABS.map(([to, label, id]) => (
      <NavLink key={to} to={to} end data-testid={id}
        className={({ isActive }) => `px-3 py-1.5 rounded-md text-sm transition-colors ${isActive ? "bg-[#357c2a] text-white" : "text-slate-600 hover:bg-slate-100"}`}>
        {label}
      </NavLink>
    ))}
  </nav>
);
